import { Box, Grid } from "@material-ui/core";
import { useContext } from "react";
import ReRegistrationAttachmentDataComponent from "../../../components/tempo/Recadastramento/ReRegistrationAttachmentDataComponent";
import FormBase from "../../../../forms/FormBase";
import FormFieldAttachmentBase, { FieldAttachment } from "../../../../forms/FormFieldAttachmentBase";
import { RecadastramentoContext } from "../../../../context/RecadastramentoContext";
import TmpTitleFormCustom from "../../../../components/tempo/TmpTitleFormCustom/TmpTitleFormCustom";
import TmpTypographyCustom from "../../../../components/tempo/TmpTypographyCustom/TmpTypographyCustom";
import TmpIconCustom from "../../../../components/tempo/TmpIconCustom/TmpIconCustom";
import { ReactComponent as IconCheck } from "../../../../assets/icons/check.svg";
import { ReRegistrationAttachmentFormItem } from "../../../../forms/recadastramento/ReRegistrationAttachmentForm";

export default function ReRegistrationAttachmentDataStep() {

    const { state, dispatch, updateFile, deleteFile, updateFileDynamic, deleteFileDynamic } = useContext(RecadastramentoContext);

    const onInputAttachmentChange = (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: FormFieldAttachmentBase) => {
        dispatch({
            type: "UPDATE_FORM_ATTACHMENT",
            payload: { form, value: fieldAttachment, name, subType: "Insert", id: "" },
        });
        updateFile(name, form, fieldAttachment, formField);
    };

    const onDeleteAttachmentChange = (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: FormFieldAttachmentBase) => {
        deleteFile(name, form, fieldAttachment, formField);
    };

    const onInputAttachmentChangeDynamic = (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: ReRegistrationAttachmentFormItem) => {
        dispatch({
            type: "UPDATE_FORM_ATTACHMENT_DYNAMIC",
            payload: { form, value: fieldAttachment, name, subType: "Insert", id: "", reRegistrationAttachmentFormItem: formField },
        });
        updateFileDynamic(name, form, fieldAttachment, formField);
    };

    const onDeleteAttachmentChangeDynamic = (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: ReRegistrationAttachmentFormItem) => {
        deleteFileDynamic(name, form, formField, fieldAttachment);
    };

    return (
        <div>

            <TmpTitleFormCustom marginTop={2}>
                Documentação
            </TmpTitleFormCustom>
            <Grid container >
                <Grid item xs={12}>
                    <TmpTypographyCustom component="heading" id="texto-documentos-enviados" size="medium" variant="h6">
                        Documentos enviados
                    </TmpTypographyCustom>
                    <Box mt={2} mb={2}>
                        <Grid container  >

                            {state.AttachmentForm.FilesInsertedInTasy === undefined || state.AttachmentForm.FilesInsertedInTasy.length === 0 ?
                                <Grid item xs={12}>
                                    <div style={{ display: "flex" }}>
                                        <TmpTypographyCustom component="caption" id="texto-data-entrega" size="medium" variant="h5">
                                            Não existe dados para serem apresentados.
                                        </TmpTypographyCustom>
                                    </div>
                                </Grid>
                                : null
                            }

                            {state.AttachmentForm.FilesInsertedInTasy !== undefined && state.AttachmentForm.FilesInsertedInTasy.map((file, index) => (
                                <Grid item xs={6} key={`${index}_dynamic_file_tasy`}>
                                    <div style={{ display: "flex" }}>
                                        <div >
                                            <TmpIconCustom icon={<IconCheck style={{ color: "green" }} />} size="lg" />
                                        </div>
                                        {file.DeliveryDate !== null && file.DeliveryDate !== undefined && file.DeliveryDate !== "" ?
                                            <div >
                                                <TmpTypographyCustom component="caption" id="texto-data-entrega" size="medium" variant="h5">
                                                    {file.Description} - Data entrega: {file.DeliveryDate}

                                                    {file.Expired ? <strong> (Expirado)</strong> : null}
                                                </TmpTypographyCustom>
                                            </div>
                                            :
                                            <div >
                                                <TmpTypographyCustom component="caption" id="texto-data-entrega" size="medium" variant="h5">
                                                    {file.Description}
                                                </TmpTypographyCustom>
                                            </div>
                                        }
                                    </div>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <TmpTypographyCustom component="heading" id="texto-documentos-faltantes" size="medium" variant="h4">
                        Documentos faltantes
                    </TmpTypographyCustom>
                    <Box mt={2} mb={5}>

                        <ReRegistrationAttachmentDataComponent
                            ReRegistrationAttachmentForm={state.AttachmentForm}
                            onInputChangeDynamic={onInputAttachmentChangeDynamic}
                            onDeleteFileDynamic={onDeleteAttachmentChangeDynamic}
                            onInputChange={onInputAttachmentChange}
                            onDeleteFile={onDeleteAttachmentChange} />
                    </Box>
                </Grid>
            </Grid>


        </div>
    );
}